// LoginUI.jsx
import LanguageDropdown from '../Common/LanguageDropdown.jsx'
import CustomSearchableDropdown from '../Common/CustomSearchableDropdown.jsx';
import DOMPurify from "dompurify";
import { useTranslation } from 'react-i18next';
import { AppConstant } from "../../config/AppConstants.js";
import { useEffect, useState } from "react";
import { Images } from "../Common/Images.jsx";

function LoginUI({ email, setEmail, setPassword, setFirstName, setLastName, handleSubmit, error, fieldError, setFieldError, showManualLogin, setShowManualLogin
    , companies, selectedCompany, setSelectedCompany, loadingCompanies, loginMethods, loadingLoginMethods, isTermsAccepted, setIsTermsAccepted, showTermsAcceptance,
    isPasswordStageUnlocked, handleForgotPassword, showForgotPasswordMessage, forgotPasswordMessage, handleRedirect, selectedLoginMethod, setSelectedLoginMethod, isNewUser, isLoading }) {

    const { t, i18n } = useTranslation("common");
    const normalizedLoginMethods = (loginMethods || []).map((method) => ({
        ...method,
        ssotype: String(method?.ssotype).toLowerCase(),
    }));

    // RON-5272 P5: when the ONLY login method is manual and terms are required, withhold the
    // password field until the user ticks the terms box AND clicks Confirm (isPasswordStageUnlocked).
    const isSingleManualMethod =
        normalizedLoginMethods.length === 1 &&
        normalizedLoginMethods[0]?.ssotype === "manual";
    const termsGateActive = showTermsAcceptance && isSingleManualMethod && !isPasswordStageUnlocked;

    const hasMicrosoftLogin = normalizedLoginMethods.find((m) => m.ssotype === "microsoft");
    const hasOnelogin = normalizedLoginMethods.find((m) => m.ssotype === "onelogin");
    const hasGmail = normalizedLoginMethods.find((m) => m.ssotype === "gmail");
    const hasOkta = normalizedLoginMethods.find((m) => m.ssotype === "okta");
    const hasDuo = normalizedLoginMethods.find((m) => m.ssotype === "duo");
    const hasSaml = normalizedLoginMethods.find((m) => m.ssotype === "saml");
    const hasMicrosoftSamlLogin = normalizedLoginMethods.find((m) => m.ssotype === "microsoft-saml");
    const hasManual = normalizedLoginMethods.find((m) => m.ssotype === "manual");


    const companyOptions = companies?.map((company) => ({
        value: String(company?.id ?? company?.Id ?? company?.CompanyId ?? ""),
        label: company?.CompanyName || company?.companyName || company?.Name || "",
    }));

    const languageCode = (i18n.language || "en").split("-")[0];
    const [showNew, setShowNew] = useState(false);
    const termsUrl = AppConstant.TERMS_LINKS[languageCode] || AppConstant.TERMS_LINKS.en;

    useEffect(() => {
        if (!showManualLogin) {
            setShowNew(false);
        }
    }, [showManualLogin]);

    useEffect(() => {
        setShowNew(false);
    }, [email]);

    const handleEmailInput = (event) => {
        setEmail(event.target.value);
        if (fieldError.field === "email") {
            setFieldError({ field: "", message: "" });
        }
    };

    return (
        <div className="main-area">
            {isLoading && (
                <div id='preloader'>
                    <img src={Images.LoaderFull} alt="" />
                </div>
            )}
            <div className="container-fluid">
                <div className="row">

                    {/* Left Panel */}
                    <div className="col-xxl-4 col-xl-5 col-12 p-0 w-38">
                        <div className="green-opacity left-panel">
                            <div className="welcome-intro">
                                {/* <span className="welcome-kicker">Ronspot</span> */}
                                <h1>{t("welcome_the_ronspot_booking_app")}</h1>
                                <p>{t("enter_your_professional_email_address_manage_bookings")}</p>
                                <ul className="checklist pb-3 d-none d-lg-block">
                                    <li>{t("view_real_time_availability_your_office")}</li>
                                    <li>{t("react_book_your_favourite_space_in_advance")}</li>
                                    <li>{t("not_coming_cancel_your_booking_anytime")}</li>
                                    <li>{t("also_available_android_ios_teams")}</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Right Panel */}
                    <div className="col-xxl-6 col-xl-7 col-12 d-flex align-items-center justify-content-center p-0 vh-full">
                        <div className="content-wrapper">
                            <div className="white-opacity blur-area login-box">
                                <div className="logo-form-wrapper">
                                    <div className="logo-with-subline text-center fade-in-animation">
                                        <div className="vertical-logo text-center">
                                            <img src={Images.RonspotSquareLogo} alt="logo" className="img-fluid" />
                                        </div>
                                        {/* <p>{t("user_signin")}</p>
                                        <span className="login-subline">{t("enter_your_professional_email_address_manage_bookings")}</span> */}
                                    </div>
                                    <div
                                        className={(isNewUser === 1 && showManualLogin) ? "form-scroll scroll-space" : ""}
                                        id="scrollableList" >
                                        {/* <div className="form-layout me-2 login-form-stage pt-0"> */}
                                        <div
                                            className={`form-layout me-2 login-form-stage ${(isNewUser === 1 && showManualLogin) ? "pt-0" : ""
                                                }`}
                                        >

                                            <form onSubmit={handleSubmit}>
                                                <div className="form-elements">
                                                    <label htmlFor="login-email" className="form-label">
                                                        {t("your_email")}
                                                    </label>
                                                    <input
                                                        /* className="form-control" */
                                                        className={`form-control ${fieldError.field === "email" ? "error-msg" : ""}`}
                                                        id="login-email"
                                                        value={email}
                                                        autoComplete="email"
                                                        onChange={handleEmailInput}
                                                    />
                                                </div>
                                                {showForgotPasswordMessage && (
                                                    <p className="success-text">{forgotPasswordMessage}</p>
                                                )}
                                                
                                                
                                                {((!showTermsAcceptance || isTermsAccepted== true) && companies.length > 0) && (
                                                    <div className="form-elements comapny-dropdown">
                                                        <label className="form-label">{t("company")}</label>

                                                        <CustomSearchableDropdown
                                                            items={companyOptions || []}
                                                            value={selectedCompany ? String(selectedCompany.id) : ""}
                                                            labelKey="label"
                                                            valueKey="value"
                                                            searchable={false}
                                                            placeholder={loadingCompanies ? "Loading..." : t("react_select_company")}
                                                            disabled={loadingCompanies || companies.length === 0}
                                                            onChange={(companyId) => {
                                                                const selected = companies.find(
                                                                    (c) => String(c.id) === String(companyId)
                                                                );

                                                                setSelectedCompany(selected);
                                                                setShowManualLogin(false);
                                                            }}
                                                        />

                                                    </div>
                                                )}

                                                {(!isNewUser && showManualLogin && !showForgotPasswordMessage && !termsGateActive) && (
                                                    <div className="form-elements">

                                                        <label htmlFor="login-pass" className="form-label">
                                                            {t("react_your_password")}
                                                        </label>
                                                        <div className="position-relative">
                                                            <input
                                                                type={showNew ? "text" : "password"}
                                                                className="form-control"
                                                                id="login-pass"
                                                                onChange={(e) => {
                                                                    setPassword(e.target.value);
                                                                    if (fieldError.field === "password") {
                                                                        setFieldError({ field: "", message: "" });
                                                                    }
                                                                }}
                                                            />
                                                            <i
                                                                className={`toggle-password fas ${showNew ? "fa-eye-slash" : "fa-eye"}`}
                                                                id="togglePassword"
                                                                onClick={() => setShowNew((prev) => !prev)}
                                                            ></i>
                                                        </div>
                                                        {fieldError.field === "password" && (
                                                            <p className="error-msg">{fieldError.message}</p>
                                                        )}
                                                        <div className="link-hover forgot-link mt-2">
                                                            <a
                                                                href="#"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    handleForgotPassword();
                                                                }}
                                                            >
                                                                {t("forgot_password")}?
                                                            </a>
                                                        </div>
                                                    </div>

                                                )}
                                                {(isNewUser === 1 && showManualLogin) && (
                                                    <>

                                                        <div className="form-elements">
                                                            <label className="form-label">{t("react_first_name")}</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                onChange={(e) => {
                                                                    setFirstName(e.target.value);
                                                                    if (fieldError.field === "firstName") {
                                                                        setFieldError({ field: "", message: "" });
                                                                    }
                                                                }}
                                                            />

                                                            {fieldError.field === "firstName" && (
                                                                <p className="error-msg">{fieldError.message}</p>
                                                            )}

                                                        </div>
                                                        <div className="form-elements">
                                                            <label className="form-label mt-3">{t("react_last_name")}</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                onChange={(e) => {
                                                                    setLastName(e.target.value);
                                                                    if (fieldError.field === "lastName") {
                                                                        setFieldError({ field: "", message: "" });
                                                                    }
                                                                }}

                                                            />
                                                            {fieldError.field === "lastName" && (
                                                                <p className="error-msg">{fieldError.message}</p>
                                                            )}

                                                        </div>
                                                        <div className="form-elements">
                                                            <label htmlFor="login-pass" className="form-label mt-3">
                                                                {t("react_your_password")}
                                                            </label>
                                                            <div className="position-relative">
                                                                <input
                                                                    type={showNew ? "text" : "password"}
                                                                    className="form-control"
                                                                    id="login-pass"
                                                                    onChange={(e) => {
                                                                        setPassword(e.target.value);
                                                                        if (fieldError.field === "password") {
                                                                            setFieldError({ field: "", message: "" });
                                                                        }
                                                                    }}
                                                                />
                                                                <i
                                                                    className={`toggle-password fas ${showNew ? "fa-eye-slash" : "fa-eye"}`}
                                                                    id="togglePassword"
                                                                    onClick={() => setShowNew((prev) => !prev)}
                                                                ></i>
                                                            </div>
                                                            {fieldError.field === "password" && (
                                                                <p className="error-msg">{fieldError.message}</p>
                                                            )}

                                                        </div>
                                                    </>
                                                )}


                                                <p className="error-msg"
                                                    dangerouslySetInnerHTML={{
                                                        __html: DOMPurify.sanitize(error)
                                                    }}
                                                ></p>

                                                {/* Terms and Conditions — RON-5272: shown only when API returns showTermsAcceptance === 1 */}
                                                {showTermsAcceptance && (
                                                    <div className="term-conditions fade-in-animation term-check">
                                                        <div className="form-group checkbox-label">
                                                            <input className="form-control" type="checkbox" id="term-condition" checked={isTermsAccepted}
                                                                onChange={(e) => setIsTermsAccepted(e.target.checked)} />
                                                            <label htmlFor="term-condition">
                                                                <div className="check-border"></div>
                                                                <p>{t("i_agree")} <a href={termsUrl} target="_blank" rel="noopener noreferrer">{t("terms_conditions")}</a></p>
                                                            </label>
                                                        </div>
                                                    </div>
                                                )}
                                                {!showForgotPasswordMessage &&
                                                !(
                                                    // company dropdown is showing and no company picked yet
                                                    (
                                                        email &&
                                                        (!showTermsAcceptance || isTermsAccepted) &&
                                                        companies.length > 0 &&
                                                        !selectedCompany
                                                    ) ||
                                                    // login-method tiles are displayed
                                                    (
                                                        (!showTermsAcceptance || isTermsAccepted) &&
                                                        loginMethods?.length > 0 &&
                                                        !showManualLogin
                                                    )
                                                ) && (
                                                        <div className="submit-btn">
                                                            <button type="submit" id="submitBtn" >{(isNewUser === 1 && showManualLogin) ? t("create_account") : ((!isNewUser && showManualLogin && !termsGateActive) ? t("react_login") : t("confirm"))}</button>
                                                        </div>
                                                    )}
                                            </form>
                                        </div>
                                    </div>
                                </div>

                                {/* Additional Content Hidden on Load */}
                                {((!showTermsAcceptance || isTermsAccepted== true) &&
                                (loginMethods?.length > 0 && !showManualLogin))
                                    && (

                                        <div className="hidden-on-load fade-in-animation login-methods-stage" id="divLoginTypes">
                                            <p className="text-center select-text">{t("and_now_select")}</p>
                                            <div className="login-options options-point">
                                                {/* {hasMicrosoft && (
                                            {/* {hasMicrosoft && (
                                                <a href="#"><img src={Images.AzureActive} alt="" /><span>{t("react_continue_with_microsoft")}</span></a>
                                            )} */}
                                                {hasMicrosoftLogin && (
                                                    <a
                                                        href="#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            setSelectedLoginMethod(hasMicrosoftLogin);
                                                            handleRedirect(hasMicrosoftLogin);
                                                        }}
                                                    >
                                                        <img src={Images.AzureActive} alt=""
                                                        />
                                                        <span>{t("react_continue_with_microsoft")}</span>
                                                    </a>
                                                )}
                                                {hasMicrosoftSamlLogin && (
                                                    <a
                                                        href="#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            setSelectedLoginMethod(hasMicrosoftSamlLogin);
                                                            handleRedirect(hasMicrosoftSamlLogin);
                                                        }}
                                                    >
                                                        <img src={Images.AzureActive} alt=""
                                                        />
                                                        <span>{t("react_continue_with_microsoft")}</span>
                                                    </a>
                                                )}
                                                {hasGmail && (
                                                    <a href="#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            setSelectedLoginMethod(hasGmail);
                                                            handleRedirect(hasGmail);
                                                        }}
                                                    ><img src={Images.GmailActive} alt="" /><span>{t("react_continue_with_gmail")}</span></a>
                                                )}
                                                {hasOkta && (
                                                    <a href="#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            setSelectedLoginMethod(hasOkta);
                                                            handleRedirect(hasOkta);
                                                        }}
                                                    ><img src={Images.OktaLogo} alt="" /><span>{t("react_continue_with_okta")}</span></a>
                                                )}
                                                {hasDuo && (
                                                    <a href="#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            setSelectedLoginMethod(hasDuo);
                                                            handleRedirect(hasDuo);
                                                        }}
                                                    ><img src={Images.DuoActive} alt="" /><span>{t("react_continue_with_duo", { defaultValue: "Continue with Duo" })}</span></a>
                                                )}
                                                {hasSaml && (
                                                    <a href="#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            setSelectedLoginMethod(hasSaml);
                                                            handleRedirect(hasSaml);
                                                        }}
                                                    ><img src={Images.SamlActive} alt="" /><span>{t("react_continue_with_saml", { defaultValue: "Continue with SAML" })}</span></a>
                                                )}
                                                {hasOnelogin && (
                                                    <a href="#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            setSelectedLoginMethod(hasOnelogin);
                                                            handleRedirect(hasOnelogin);
                                                        }}
                                                    ><img src={Images.OneloginActive} alt="" /><span>{t("react_continue_with_onelogin")}</span></a>
                                                )}
                                                {hasManual && (
                                                    <a
                                                        href="#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            setSelectedLoginMethod(hasManual);
                                                            //handleRedirect(hasManual);
                                                            setShowManualLogin(true);
                                                        }}
                                                    >
                                                        <img src={Images.EmailActive} alt="" />
                                                        <span>{t("react_continue_with_email")}</span>
                                                    </a>
                                                )}

                                            </div>
                                        </div>

                                    )}
                            </div>

                        </div>
                    </div>

                </div>
            </div>

            {/* Start Language Dropdown */}
            <LanguageDropdown />
            {/* End Language Dropdown */}

        </div >
    );
}

export default LoginUI;
